import React from 'react';
import { DeviceFrameset } from 'react-device-frameset';
import 'react-device-frameset/styles/marvel-devices.min.css';

interface DeviceFrameProps {
  device: 'iPhone X' | 'iPad Mini' | 'MacBook Pro';
  color?: 'black' | 'silver';
  landscape?: boolean;
  zoom?: number;
  objectFit?: 'cover' | 'contain';
  imgPadding?: number;
  screenshot: string;
  alt: string;
  label: string;
}

export default function DeviceFrame({
  device,
  color,
  landscape,
  zoom = 1,
  objectFit = 'cover',
  imgPadding = 0,
  screenshot,
  alt,
  label,
}: DeviceFrameProps) {
  const deviceProps: any = { device };
  if (color) deviceProps.color = color;
  if (landscape) deviceProps.landscape = true;

  const objectFitClass = objectFit === 'contain' ? 'object-contain' : 'object-cover';

  return (
    <div className="flex flex-col items-center">
      <div style={{ zoom }}>
        <DeviceFrameset {...deviceProps}>
          <div className="w-full h-full bg-white flex items-start justify-center" style={{ padding: imgPadding }}>
            <img
              src={screenshot}
              alt={alt}
              className={`w-full h-full object-top ${objectFitClass}`}
            />
          </div>
        </DeviceFrameset>
      </div>
      <span className="mt-3 text-xs sm:text-sm font-medium text-gray-400 tracking-wide uppercase">
        {label}
      </span>
    </div>
  );
}
